export function patchDisplayNameIfMissing(shortcuts, plug) {
    Object.values(shortcuts).forEach((shortcuts) => {
        (Array.isArray(shortcuts) ? shortcuts : [shortcuts]).forEach((s) => {
            if (!s.displayName && !s.name) {
                // TS 编译后 class method variable 的名字会丢失，这里尝试遍历 key 来找到
                const keyInPlug = Object.keys(plug).find((key) => plug[key] === s);
                s.displayName = `${plug.name}Plugin.${keyInPlug || 'anonymous'}`;
            }
        });
    });
}
//# sourceMappingURL=shortcut.js.map